import { CaseAdmin, LabOrder } from "pwapi";

import { useSortedBlocks } from "shared/hooks/useSortedCase";

import HiddenDropDown from "../filters/HiddenDropdown";
import CopyBlockButton from "../ordersTable/CopyBlockButton";
import OrdersTable from "../ordersTable/OrdersTable";

type OrdersProps = {
  adminCase: CaseAdmin;
  ordersWithoutSlides?: LabOrder[];
};

const Orders = ({ adminCase, ordersWithoutSlides }: OrdersProps) => {
  const labOrders = adminCase.lab_orders || [];
  const blocks = useSortedBlocks(adminCase);
  const filteredBlocks = blocks.filter((block) =>
    labOrders.some((lab_order) => lab_order.block_id === block.id)
  );

  return (
    <div className="panelContainer panelContainer--gap">
      {filteredBlocks.map((block) => {
        return (
          <HiddenDropDown
            label={block.full_name}
            isInitOpen
            type="largeLabel"
            key={block.id}
            labelActions={
              block.id ? <CopyBlockButton block_id={block.id} /> : null
            }
          >
            <OrdersTable
              ordersWithoutSlides={ordersWithoutSlides}
              orders={labOrders.filter(
                (labOrder) => labOrder.block_id === block.id
              )}
            />
          </HiddenDropDown>
        );
      })}
    </div>
  );
};

export default Orders;
